import PropTypes from "prop-types";
import { useSnackbar } from "notistack";
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { isNull } from "lodash";
import { useForm } from "react-hook-form";

export const CustomerSitesContext = createContext(null);

const timeDummy = [
  {
    id: 1,
    checkpoint: "Checkpoint 1",
    radius: "20",
    qr: "",
  },
  {
    id: 2,
    checkpoint: "Checkpoint 2",
    radius: "20",
    qr: "",
  },
  {
    id: 3,
    checkpoint: "Checkpoint 3",
    radius: "20",
    qr: "",
  },
];

export const CustomerSitesProvider = ({ children }) => {
  const [customerSitesDetails, setCustomerSitesDetails] = useState();
  const [siteCheckpoints, setSiteCheckpoints] = useState();
  const [isEnable, setIsEnable] = useState(false);
  const methods = useForm({
    mode: "all",
    reValidateMode: "all",
    defaultValues: {},
  });

  const memoizedValue = useMemo(
    () => ({
      methods,
      isEnable,
      setIsEnable,
      customerSitesDetails,
      setCustomerSitesDetails,
      siteCheckpoints,
      setSiteCheckpoints,
    }),
    [
      methods,
      isEnable,
      setIsEnable,
      customerSitesDetails,
      setCustomerSitesDetails,
      siteCheckpoints,
      setSiteCheckpoints,
    ]
  );

  return (
    <CustomerSitesContext.Provider value={memoizedValue}>
      {children}
    </CustomerSitesContext.Provider>
  );
};

export const useCustomerSitesContext = () => {
  const context = useContext(CustomerSitesContext);

  if (!context)
    throw new Error(
      "useCustomerSitesContext context must be use inside CustomerSitesProvider"
    );

  return context;
};

CustomerSitesProvider.propType = {
  children: PropTypes.node,
};

// ----------------------------------------------------------------------
